// src/pages/Returns/Returns.jsx
//
// ВОЗВРАТ ТОВАРА (черновик).
//
// ⚠️ ЧЕРНОВИК. Владелец: «Юридические тексты напиши пробные сам, я потом
//    сам их исправлю». Требует проверки юристом и заполнения реквизитов.
//
// 🔴 ЧТО ЗДЕСЬ ПРИНЦИПИАЛЬНО:
//    1. Ст. 26.1 Закона «О защите прав потребителей» (ЗоЗПП): при
//       дистанционной продаже покупатель вправе отказаться от товара в любое
//       время до передачи и в течение 7 дней после. Это ЗАКОН, а не политика
//       магазина — нельзя написать «возврат 3 дня».
//    2. Ст. 25 ЗоЗПП: обмен/возврат товара надлежащего качества — 14 дней,
//       но только для товаров, не бывших в употреблении, с сохранением вида
//       и при наличии чека (отсутствие чека не лишает права — важно!).
//    3. Перечень товаров, НЕ подлежащих возврату, утверждён Постановлением
//       Правительства РФ от 31.12.2020 № 2463. Товары по индивидуальному
//       заказу попадают под ограничения — но это надо формулировать
//       аккуратно, а не «ничего не возвращаем».
//    4. Срок возврата денег — не позднее 10 дней со дня требования
//       (ст. 26.1 п. 4 ЗоЗПП). Указать явно.
import React from 'react';
import {
  LegalPage,
  LegalSection,
  LegalList,
} from '../../components/common/LegalPage/LegalPage.jsx';
import { REQUISITES, REQUISITES_ADDRESS } from '../../utils/requisites.js';

export const Returns = () => (
  <LegalPage
    title="Возврат товара"
    intro="Настоящая страница описывает порядок возврата товара и отказа от договора при покупке товаров дистанционным способом через сайт рекламного агентства «Студия Рекламы»."
  >
    <LegalSection number="1" title="Общие положения">
      <p>
        1.1. Порядок возврата определяется Гражданским кодексом Российской
        Федерации, Законом Российской Федерации от 07.02.1992 № 2300-1
        «О защите прав потребителей» (далее — ЗоЗПП), а также настоящими
        условиями.
      </p>
      <p>
        1.2. Продавец: {REQUISITES.legalName}, ИНН {REQUISITES.inn},
        адрес: {REQUISITES_ADDRESS}, email: {REQUISITES.email},
        телефон: {REQUISITES.phone}.
      </p>
    </LegalSection>

    <LegalSection number="2" title="Отказ от товара до передачи">
      <p>
        2.1. Покупатель вправе отказаться от товара в любое время до его
        передачи. Для этого достаточно направить Продавцу уведомление любым
        доступным способом: по электронной почте, телефону или через форму
        обратной связи на сайте.
      </p>
      <p>
        2.2. При отказе до передачи товара Продавец возвращает уплаченную
        Покупателем сумму, за исключением расходов Продавца на доставку
        товара от Покупателя, если такие расходы понесены.
      </p>
    </LegalSection>

    <LegalSection number="3" title="Возврат товара надлежащего качества">
      <p>
        3.1. Покупатель вправе отказаться от товара после его получения в
        течение <strong>семи дней</strong> (пункт 4 статьи 26.1 ЗоЗПП).
      </p>
      <p>
        3.2. Возврат товара надлежащего качества возможен при соблюдении
        следующих условий:
      </p>
      <LegalList
        items={[
          'товар не был в употреблении, сохранены его товарный вид и потребительские свойства;',
          'сохранена документация и (или) упаковка, насколько это возможно;',
          'имеется документ, подтверждающий факт и условия покупки.',
        ]}
      />
      <p>
        3.3. <strong>Отсутствие документа, подтверждающего покупку, не лишает
        Покупателя права</strong> ссылаться на другие доказательства
        приобретения товара у данного Продавца (пункт 5 статьи 18, пункт 4
        статьи 26.1 ЗоЗПП).
      </p>
      <p>
        3.4. При отказе от товара надлежащего качества Продавец возвращает
        уплаченную сумму, за исключением расходов на доставку от Покупателя,{' '}
        <strong>не позднее чем через десять дней</strong> со дня предъявления
        соответствующего требования (пункт 4 статьи 26.1 ЗоЗПП).
      </p>
    </LegalSection>

    <LegalSection number="4" title="Товар ненадлежащего качества">
      <p>
        4.1. При обнаружении недостатков товара Покупатель вправе по своему
        выбору потребовать:
      </p>
      <LegalList
        items={[
          'безвозмездного устранения недостатков товара или возмещения расходов на их устранение;',
          'соразмерного уменьшения покупной цены;',
          'замены на товар аналогичной марки (модели, артикула);',
          'возврата уплаченной суммы и отказа от исполнения договора.',
        ]}
      />
      <p>
        4.2. Требования рассматриваются в сроки, установленные ЗоЗПП.
        Проверка качества товара при необходимости проводится в порядке,
        предусмотренном законодательством.
      </p>
    </LegalSection>

    <LegalSection number="5" title="Товары, изготовленные по индивидуальному заказу">
      <p>
        5.1. Часть товаров изготавливается по индивидуально-определённым
        характеристикам Покупателя (размеры, материал, цвет, макет, текст).
      </p>
      <p>
        5.2. Возврат и обмен таких товаров надлежащего качества не
        производится, если товар изготовлен в соответствии с согласованными
        сторонами параметрами и не имеет недостатков. Это соответствует
        перечню, утверждённому Постановлением Правительства Российской
        Федерации от 31.12.2020 № 2463.
      </p>
      <p>
        5.3. Если изготовленный товар не соответствует согласованным
        параметрам или имеет недостатки, Покупатель вправе предъявить
        требования, предусмотренные разделом 4 настоящей страницы.
      </p>
      <p>
        5.4. Во избежание разногласий параметры индивидуального заказа
        согласуются сторонами до начала изготовления. Такое согласование
        фиксируется в переписке или в документах заказа.
      </p>
    </LegalSection>

    <LegalSection number="6" title="Как оформить возврат">
      <p>6.1. Для оформления возврата Покупателю необходимо:</p>
      <LegalList
        items={[
          'связаться с Продавцом по указанным контактам и сообщить номер заказа;',
          'заполнить заявление на возврат, указав причину и реквизиты для возврата денежных средств;',
          'согласовать способ передачи товара Продавцу.',
        ]}
      />
      <p>
        6.2. Возврат денежных средств производится тем же способом, которым
        была произведена оплата, если стороны не согласовали иное.
      </p>
      <p>
        6.3. Расходы на обратную доставку товара надлежащего качества несёт
        Покупатель, если иное не согласовано сторонами. При возврате товара
        ненадлежащего качества расходы несёт Продавец.
      </p>
    </LegalSection>

    <LegalSection number="7" title="Сроки рассмотрения обращений">
      <LegalList
        items={[
          'возврат денежных средств при отказе от товара — не позднее 10 дней со дня предъявления требования;',
          'рассмотрение требования о замене товара — в сроки, установленные ЗоЗПП;',
          'ответ на обращение Покупателя — в течение 10 дней, если иной срок не установлен законом.',
        ]}
      />
      <p>
        7.1. Если обращение требует дополнительной проверки качества товара,
        Продавец уведомляет Покупателя о продлении срока с указанием причин.
      </p>
    </LegalSection>

    <LegalSection number="8" title="Заключительные положения">
      <p>
        8.1. Настоящие условия не ограничивают прав потребителя,
        предусмотренных законодательством Российской Федерации. В случае
        противоречия настоящих условий и закона применяются нормы закона.
      </p>
      <p>
        8.2. Действующая редакция: версия 1.0. Актуальный текст постоянно
        доступен по адресу {REQUISITES.siteUrl}/returns.
      </p>
    </LegalSection>
  </LegalPage>
);
